<template>
  <div>
    <Head title="Dashboard" />
    <h1 class="mb-8 text-3xl font-bold">
      Dashboard
    </h1>
    <p class="mb-8 leading-normal">
      Selamat datang di Sistem Informasi Logistik YEU
    </p>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'

export default {
    components: {
        Head,
    },
    layout: Layout,
}
</script>
